import { VueUmamiPlugin } from '@jaseeey/vue-umami-plugin';
import env from 'configs/env';
import { boot } from 'quasar/wrappers';

export default boot(({ app, router }) => {
    if (!env.umamiWebsiteId) {
        return;
    }
    app.use(VueUmamiPlugin({
        websiteID: env.umamiWebsiteId,
        router
    }));
})
